export default "https://cdn-static.gokick.com/assets/1a6b0e419037e7f05bc52ad73a019b5bb7bc4745/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";